import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FiPhone, FiMail } from 'react-icons/fi';
import './ContactSection.css';

const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="contact" className="contact-section" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2>Need Help? Contact Us</h2>
          <p>Feel free to reach out to us for any queries</p>
        </motion.div>

        <motion.div
          className="contact-grid"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.div 
            className="contact-card"
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="contact-icon">
              <FiPhone />
            </div>
            <div className="contact-info">
              <h4>Bride's Family</h4>
              <a href="tel:+918139055046">+91 - 8139055046</a>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-card"
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="contact-icon">
              <FiPhone />
            </div>
            <div className="contact-info">
              <h4>Groom's Family</h4>
              <a href="tel:+919446242609">+91 - 9446242609</a>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-card"
            whileHover={{ scale: 1.05, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="contact-icon">
              <FiMail />
            </div>
            <div className="contact-info">
              <h4>Email Us</h4>
              <a href="mailto:wedding@kozhippalli.com">wedding@kozhippalli.com</a>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;

